
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg-icon",classNames,staticClass],
              style: [{"width":"1em","height":"1em","vertical-align":"middle"},style,staticStyle],
              attrs: Object.assign({"style":"width:1em;height:1em;vertical-align:middle","viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","overflow":"hidden"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M170.667 170.667h256v256h-256v-256m682.666 0v256h-256v-256h256M597.333 640h85.334v-85.333h-85.334v-85.334h85.334v85.334H768v-85.334h85.333v85.334H768V640h85.333v128H768v85.333h-85.333V768h-128v85.333h-85.334V682.667h128V640m85.334 0v128H768V640h-85.333m-512 213.333v-256h256v256h-256M256 256v85.333h85.333V256H256m426.667 0v85.333H768V256h-85.333M256 682.667V768h85.333v-85.333H256m-85.333-213.334H256v85.334h-85.333v-85.334m213.333 0h170.667V640h-85.334v-85.333H384v-85.334M469.333 256h85.334v170.667h-85.334V256m-384-170.667V256H0V85.333A85.333 85.333 0 0185.333 0H256v85.333H85.333M938.667 0A85.333 85.333 0 011024 85.333V256h-85.333V85.333H768V0h170.667M85.333 768v170.667H256V1024H85.333A85.333 85.333 0 010 938.667V768h85.333m853.334 170.667V768H1024v170.667A85.333 85.333 0 01938.667 1024H768v-85.333h170.667z"}})])
          )
        }
      }
    